import { gateway } from "../../../gateway";
import { IResendEventDeliveryLogResponse } from "../interfaces";

export const resendEventDeliveryLog = async (logUid: string): Promise<IResendEventDeliveryLogResponse> => {
  const response = await gateway.post(`/event-delivery/logs/${logUid}/resend`);
  return response?.data?.data;
};
